import React, { Component } from "react";
import { connect } from "react-redux";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import IrqChoiceButtons from "../molecules/IrqChoiceButtons";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import ILearn from "../molecules/ILearn";

const VALUES = [true, false];

const navigationCallback = ({ navigationsAway, values, index }) => {
  const foundIndex =
    typeof index !== "undefined"
      ? index
      : VALUES.findIndex((v) => v === values.isVeteran);

  return foundIndex === 0 ? navigationsAway.Primary : navigationsAway.Secondary;
};

class IrqVeteranView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle
            content={this.props.content}
            icon="/img/svg_icons/va_eligible.svg"
          />
          <IrqChoiceButtons
            content={this.props.content}
            value={this.props.data.isVeteran}
            values={VALUES}
            onChoiceMade={(index) => {
              this.props.customFormEdit("isVeteran", VALUES[index]);
              const navigateTo = navigationCallback({ index, ...this.props });
              this.props.navigationContext.goNext(navigateTo, true);
            }}
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(
  connect()(IrqVeteranView),
  navigationCallback
);
